import { render } from "./textEditor.vue?vue&type=template&id=0dd0991a&scoped=true"
import script from "./textEditor.vue?vue&type=script&lang=js"
export * from "./textEditor.vue?vue&type=script&lang=js"

import "./textEditor.vue?vue&type=style&index=0&id=0dd0991a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd0991a"]])

export default __exports__